import React from 'react';
import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import ScopeActionChip from './scope_action_chip';
import { selectionState } from './selection';
import { ChipRow, ResourceRowWrapper } from './styled_components';
import { ScopeResource } from './types';

type ReadOnlyProps = {
  resource: ScopeResource;
  readOnly: true;
};

type EditableProps = {
  resource: ScopeResource;
  readOnly?: false;
  selected: Set<string>;
  onToggleScope: (name: string) => void;
  onSetScopes: (names: string[], checked: boolean) => void;
};

type Props = ReadOnlyProps | EditableProps;

export default function ScopeResourceRow(props: Props) {
  const { resource } = props;
  const names = resource.scopes.map((scope) => scope.name);
  const state = props.readOnly ? null : selectionState(names, props.selected);

  return (
    <div>
      {props.readOnly ? (
        <Body>
          <strong>{resource.label}</strong>
        </Body>
      ) : (
        <Checkbox
          checked={state === 'all'}
          indeterminate={state === 'some'}
          onChange={(checked: boolean) => props.onSetScopes(names, checked)}
          label={resource.label}
          value={resource.key}
        />
      )}
      <ResourceRowWrapper>
        <ChipRow>
          {resource.scopes.map((scope) =>
            props.readOnly ? (
              <ScopeActionChip key={scope.name} scope={scope} readOnly />
            ) : (
              <ScopeActionChip
                key={scope.name}
                scope={scope}
                selected={props.selected.has(scope.name)}
                onToggle={props.onToggleScope}
              />
            )
          )}
        </ChipRow>
      </ResourceRowWrapper>
    </div>
  );
}
